import React, { useEffect } from 'react';
import ReceiptLayout from '../receipt.layout';
import { useReceiptContext } from '../context/receipt.context';
import { useTrackingContext, formAction } from '@jbhi-fi/components/src/Tracking';
import ReceiptHelper from '../helpers/receipt.helper';
const receiptHelper = new ReceiptHelper();

const PostLoginView = ({ receiptId, history }) => {
  const { data, clearSession, isLinked } = useReceiptContext();
  const { tracker } = useTrackingContext();

  useEffect(() => {
    if (receiptId && receiptId === data?.receipt?.ReceiptData?.Code) {
      const customerId = window.Jbhifi?.shopifyCustomerId;

      if (!customerId || !data.verify) {
        history.push(`/${receiptId}`);
      } else if (data.verify?.isTooManyAttempts) {
        history.push('/lockedout');
      } else if (data.verify.isSuccess) {
        if (!data.verify?.raw?.data?.phone && !isLinked) {
          history.push(`/${receiptId}/verify`);
        } else {
          clearSession();
          receiptHelper.redirectToAccount(receiptId);
        }
      } else if (data.receipt.ErrorCode === 'InvalidReceiptCode' || data.receipt.ErrorCode === 'InvalidData') {
        history.push(`/`);
      }
    }
  }, [data]);

  useEffect(() => {
    tracker.group = 'post login';
    tracker.trackFormEvent({ action: formAction.stepView, extraData: { data: { value: receiptId } } });
  }, []);

  return <ReceiptLayout isLoading={true} />;
};

export default PostLoginView;
